// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Survey_wrapper__e38_p","question-number":"Survey_question-number__NU8oa","options":"Survey_options__DFvBA"};